import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Form, Input, Button, notification, Spin
} from 'antd';
import { get } from 'lodash';
import './Login.less';
import Cookies from 'js-cookie';
import API from '../../utils/Api';

class LoginContainer extends Component {
  constructor(props) {
    super(props);
    this.searchValue = get(props, 'location.search', '').split('?');
    this.value = this.searchValue[1] && this.searchValue[1].indexOf('=');
    this.api = new API({});
    this.api.createEntity({ name: 'user' });
    this.state = {
      loading: false,
      token: this.searchValue[1] ? this.searchValue[1].slice(this.value + 1) : '',
    };
  }

  componentDidMount() {
    if (this.state.token) {
      this.setState({ loading: true });
      const formData = {
        token: this.state.token,
      };
      Object.keys(Cookies.get()).forEach((cookie) => {
        Cookies.remove(cookie);
      });
      this.api.endpoints.user.create(formData, {}, 'verify-detail').then((data) => {
        if (get(data, 'data.success', false)) {
          Cookies.set('RoleName', get(data, 'data.data.RoleName', ''), {SameSite:'None', Secure:true});
          Cookies.set('appID', get(data, 'data.data.app_id', ''), {SameSite:'None', Secure:true});
          Cookies.set('apiUrl', get(data, 'data.data.apiUrl', ''),{SameSite:'None', Secure:true});
          Cookies.set('camp_appName', get(data, 'data.data.app_name', ''),{SameSite:'None', Secure:true});
          Cookies.set('UserName', get(data, 'data.data.app_name', ''), {SameSite:'None', Secure:true});
          Cookies.set('appKey', get(data, 'data.data.app_key', ''), {SameSite:'None', Secure:true});
          Cookies.set('tenant_id', get(data, 'data.data.tenant_id', ''), {SameSite:'None', Secure:true});
          this.setState({ loading: false });
          this.props.history.push('/campaign/all-campaigns');
        }
        const campName = Cookies.get("camp_appName") || "";
        if(!campName){
        notification.success({ message: 'Login successfully' });
        }
      }).catch((err) => {
        notification.error({ message: `Failed to login.${err}` });
        this.setState({ loading: false });
      });
    }
  }

  onFinish = (values) => {
    const { email, password } = values;
    if (email && password) {
      this.setState({ loading: true });
      Object.keys(Cookies.get()).forEach((cookie) => {
        Cookies.remove(cookie);
      });
      this.api.endpoints.user
        .auth({ email, password }, { url: '/auth' })
        .then(({ data }) => {
          const {
            success, UserName, token,
            RoleName, appName, userID,
          } = data;
          if (success) {
            this.setState({ loading: false });
            Cookies.set('UserName', UserName);
            Cookies.set('user_id', userID);
            Cookies.set('email_id', email);
            Cookies.set('token', token);
            Cookies.set('RoleName', RoleName);
            if (RoleName === 'super admin') {
              this.props.history.push('/user');
            }
            if (RoleName === 'app admin' || RoleName === 'app developer') {
              if (appName.length === 1) {
                Cookies.set('projectName', appName[0].kl_app.app_name);
                Cookies.set('appID', appName[0].app_id);
              } else {
                Cookies.set('appName', appName);
              }
              this.props.history.push('/channels');
            }
            notification.success({ message: 'Login successfully' });
          }
        })
        .catch((err) => {
          notification.error({ message: `Failed to login.${err}` });
          this.setState({ loading: false });
        });
    }
  };

  render() {
    const { loading } = this.state;
    return (
      <>
        {loading ? (
          <div className='spin'>
          <Spin  spinning={loading} />
          </div>
        ) : (
          <>
            <div className="block">
              <div className="block__container">
                <div className="block-content">
                  <div>
                    <div>
                      <h2 className="mb-3">Login</h2>
                      <Form
                        name="login"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                      >
                        <div>
                          <Form.Item
                            name="email"
                            rules={[
                              {
                                required: true,
                                message: "Please enter your Email!",
                              },
                            ]}
                          >
                            <Input placeholder="Email address" />
                          </Form.Item>
                        </div>
                        <div>
                          <Form.Item
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: "Please enter your password!",
                              },
                            ]}
                          >
                            <Input.Password placeholder="Password" />
                          </Form.Item>
                        </div>
                        <div className="flex-bwn-end">
                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              disabled={loading}
                            >
                              {loading ? "Loading..." : "Login"}
                            </Button>
                          </Form.Item>
                          <Form.Item>
                            <Link to="/forget-password">Forgot Password?</Link>
                          </Form.Item>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default LoginContainer;
